import request from '@/utils/request'

export function changePassword(data) {
  return request.post('/auth/change-password', data)
}
